export enum TipoAnagraficaCampoSpecificoEnum {
  IMPRESA = <any>"IMPRESA",
  CITTADINO = <any>"CITTADINO",
  ASSOCIAZIONE = <any>"ASSOCIAZIONE",
  PUBBLICA_AMMINISTRAZIONE = <any>"PUBBLICA_AMMINISTRAZIONE",
}
